<script>
import _ from 'lodash'
import CredentialTable from '../common/CredentialsTable.vue'
import ToggleCredential from '../common/ToggleCredential.vue'
import UniqueRoleSelect from '@/components/backoffice/common/UniqueRoleSelect.vue'

export default {
  components: {
    UniqueRoleSelect,
    CredentialTable,
    ToggleCredential
  },
  props: {
    // user-view response
    value: {
      type: Array
    },
    loading: {
      type: Boolean
    },
    // roleView response
    roles: {
      type: Array
    }
    /*     uniqueRoles: {
          type: Array
        } */
  },
  data() {
    return {
      drawer: { state: false, data: {} },
      headers: [
        {
          text: this.$t('component.backoffice.userManagement.header.tam.id'),
          align: 'start',
          value: 'user.id',
          width: 100
        },
        {
          text: this.$t('component.backoffice.userManagement.header.apl.id'),
          align: 'start',
          value: 'user.aplId',
          width: 120
        },
        {
          text: this.$t('component.backoffice.userManagement.header.username'),
          align: 'start',
          value: 'user.userName'
        },
        {
          text: this.$t('component.backoffice.userManagement.header.first.name'),
          align: 'start',
          value: 'user.firstName'
        },
        {
          text: this.$t('component.backoffice.userManagement.header.last.name'),
          align: 'start',
          value: 'user.lastName'
        },
        {
          text: this.$t('component.backoffice.userManagement.header.organization'),
          align: 'start',
          value: 'user.organizationName'
        },
        {
          text: this.$t('component.backoffice.userManagement.header.roles'),
          align: 'start',
          value: 'user.roles'
        }
      ],
      search: '',
      credentials: { roles: [], permissions: [], uniqueRole: [], multipleRole: [] },
      invoiceRoles: [],
      userRole: [],
      uniqueRoles: [],
      multipleRoles: [],
      adminRole: [],
      orgaAdminRole: [],
      MultiUser: [],
      alertRoles: [],
      alertRole: [],
      roleAlert: false,
      sanitizedUniqueUserRole: ''
    }
  },
  created() {
    this.invoiceRoles = _.filter(this.roles, {
      permissions: [{ permission: 'SkipPayment' }]
    }).map(role => {
      return role.role
    })
    this.userRole = _.filter(this.roles, {
      permissions: [{ permission: 'CreditAccount' }]
    }).map(role => {
      return role.role
    })
    this.adminRole = _.filter(this.roles, {
      role: 'Administrator'
    }).map(role => {
      return role.role
    })
    this.orgaAdminRole = _.filter(this.roles, {
      role: 'OrganizationAdmin'
    }).map(role => {
      return role.role
    })
    this.orgaMember = _.filter(this.roles, {
      role: 'OrganizationMember'
    }).map(role => {
      return role.role
    })
    // this.multipleRoles = this.adminRole.concat(this.orgaAdminRole).concat(this.orgaMember)
    this.multipleRoles = _.filter(this.roles, role => {
      return !_.some(role.permissions, { permission: 'SkipPayment' }) && role.role !== 'SuperAdmin' && role.role !== 'User'
    }).map(role => {
      return role.role
    })
    this.uniqueRoles = this.invoiceRoles.concat(this.userRole)
    this.credentials.uniqueRole.push(this.uniqueRoles)
    this.credentials.multipleRole.push(this.multipleRoles)
  },
  methods: {
    openDrawer(event) {
      this.drawer.state = true
      this.drawer.data = event
      this.setCredentialState()
      // console.info("user roles", this.drawer.data.user.roles)
    },
    // sets the credential-state (roles and permissions) for the selected user
    setCredentialState() {
      // set state for roles
      this.credentials.roles = this.roles.reduce((acc, value) => {
        acc.push({
          name: value.role,
          checked: this.drawer.data.user.roles.includes(value.role)
        })
        return acc
      }, [])
      this.credentials.multipleRole = this.multipleRoles.reduce((acc, value) => {
        acc.push({
          name: value,
          checked: this.drawer.data.user.roles.includes(value)
        })
        return acc
      }, [])
      this.credentials.uniqueRole = this.uniqueRoles
      this.sanitizedUniqueUserRole = _.union(this.drawer.data.user.roles, this.invoiceRoles)[0]
      this.getUniqueRoleAlert()
      // set state for permissions
      this.credentials.permissions = Object.values(
        this.$enums.permissions
      ).reduce((acc, value) => {
        acc.push({
          name: value,
          checked: this.drawer.data.user.permissions.includes(value)
        })
        return acc
      }, [])
    },
    getUniqueRoleAlert() {
      this.alertRoles = _.intersection(this.drawer.data.user.roles, this.invoiceRoles)
    },
    getAlert() {
      this.getUniqueRoleAlert()
      return this.alertRoles.length > 1;
    },
    canToggleCredential(credentialName, aplId) {
      return !(!aplId && this.invoiceRoles.includes(credentialName));
    },
    async updateUser() {
      return await this.$backofficeService
        .userView({ query: 'userId=' + this.drawer.data.user.id })
        .then(response => {
          let user = response.userResponseDTOs[0].user
          this.drawer.data.user.roles = user.roles
          this.drawer.data.user.permissions = user.permissions
          this.setCredentialState()
          this.drawer.state = false

        })
    }
  }
}
</script>
<template>
  <div>
    <v-sheet class="overflow-hidden" style="position: relative">
      <v-data-table
        :headers="headers"
        :items="value"
        :items-per-page="15"
        :loading="loading"
        :loading-text="$t('component.backoffice.userManagement.loading')"
        class="elevation-1"
        style="cursor: pointer"
        :search="search"
        calculate-widths
        @click:row="openDrawer">
        <template #top>
          <v-text-field
            id="search"
            v-model="search"
            label="Suchen"
            class="mx-4">
          </v-text-field>
        </template>
        <template #[`item.user.organizationName`]="{item}">
          <v-tooltip top>
            <template #activator="{ on, attrs }">
              <span
                v-if="item.user.organizations"
                v-bind="attrs"
                v-on="on">
                <span v-if="item.user.organizations[0]">{{ item.user.organizations[0].organizationName }}</span>
                <span v-if="item.user.organizations.length > 1">
                  ...
              </span>
              </span>
            </template>
            <span v-for="(organization,index) in item.user.organizations" :key="index">
            <span v-if="organization.organizationName">{{ organization.organizationName }} </span><br>
          </span>
          </v-tooltip>
        </template>
        <template #[`item.user.userName`]="{ item }">
          <v-tooltip top>
            <template #activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">{{ item.user.userName }}</span>
            </template>
            <span>ID: {{ item.user.id }}</span>
          </v-tooltip>
        </template>
        <template #[`item.user.roles`]="{ item }">
          <v-chip
            v-for="(role,index) in item.user.roles"
            :key="index"
            color="primary"
            class="ma-1">
            {{ role }}
          </v-chip>
        </template>
      </v-data-table>
      <v-navigation-drawer
        v-model="drawer.state"
        width="540"
        temporary
        right
        app>
        <div v-if="drawer.state" class="ml-4 mr-4">
          <v-card dense flat>
            <v-card-title class="pl-0 pb-0">
              <b>{{ drawer.data.user.userName }}</b>
            </v-card-title>
            <div class="pb-8"></div>
          </v-card>
          <v-card v-if="getAlert() && !$roles.isSuperAdmin">
            {{$t('component.backoffice.userManagement.two.roles.warning')}}
          </v-card>
          <!--  checkboxen mit mehrfachauswahl -->
          <v-expansion-panels :value="[0,1]" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>{{$t('component.backoffice.userManagement.roles.with.payment.method')}}</v-expansion-panel-header>
              <v-expansion-panel-content>
                <!-- radiobuttons nur einzelauswahl möglich -->
                <UniqueRoleSelect
                  :current="sanitizedUniqueUserRole"
                  :list="credentials.uniqueRole"
                  :invoice-roles="invoiceRoles"
                  :user="drawer.data.user"
                  class="pt-0"
                  @updated:role="updateUser" />
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>{{$t('component.backoffice.userManagement.roles.without.payment.method')}}</v-expansion-panel-header>
              <v-expansion-panel-content>
                <CredentialTable :items="credentials.multipleRole">
                  <template #item="slotProps">
                    <v-tooltip top>
                      <template #activator="{ on, attrs }">
                        <v-icon
                          v-if="!canToggleCredential(
                            slotProps.credential.name,
                            drawer.data.user.aplId)"
                          color="red"
                          v-bind="attrs"
                          v-on="on">
                          mdi-information
                        </v-icon>
                      </template>
                      <span>{{$t('component.backoffice.userManagement.apl.id.missing')}}</span>
                    </v-tooltip>
                    <ToggleCredential
                      :disabled="!canToggleCredential(
                        slotProps.credential.name,
                        drawer.data.user.aplId)"
                      :credential="slotProps.credential"
                      :user="drawer.data.user"
                      @change="updateUser" />
                  </template>
                </CredentialTable>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>{{$t('component.backoffice.userManagement.permissions')}}</v-expansion-panel-header>
              <v-expansion-panel-content>
                <CredentialTable :items="credentials.permissions">
                  <template #item="slotProps">
                    <ToggleCredential :credential="slotProps.credential" disabled />
                  </template>
                </CredentialTable>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </v-navigation-drawer>
    </v-sheet>
  </div>
</template>